
import { Menu, Button, Modal, Skeleton } from "antd";
import { useState, useContext, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { QuestionCircleFilled } from '@ant-design/icons';
import moment from "moment";
import logo from "../../assets/images/logo-small.png";
import {
  Gauge,
  Users,
  Copyright,
  Building2,
  Car,
  Boxes,
  List,
  Layers,
  Package,
  BookOpen,
  Cube,
  FolderTree,
  Flag,
  Building,
  Globe,
  Settings,
  CurlyBraces,
  LogOutIcon,
  ListCheck,
  IndianRupee,
} from "lucide-react";

export const menuItems = [
  {
    key: "Dashboard",
    path: "/dashboard",
    icon: <Gauge size={18} />,
    label: "Dashboard"
  },
  {
    key: "UserSection",
    path: "/user",
    icon: <Users size={18} />,
    label: "User Manager"
  },
  {
    key: "SegmentMenu",
    path: "/segment",
    label: "Segment Manager",
    icon: <Globe size={18} />,
  },
  {
    key: "CategoryMenu",
    path: "/category",
    label: "Category Manager",
    icon: <List size={18} />,
  },
  {
    key: "SubCategoryMenu",
    path: "/sub-category",
    label: "Sub Category Manager",
    icon: <Layers size={18} />,
  },
  {
    key: "BrandMenu",
    path: "/brand",
    label: "Brand Manager",
    icon: <Copyright size={18} />,
  },
  {
    key: "VehicleManufacturerMenu",
    path: "/vehicle-manufacturer",
    label: "Vehicle Manufacturer Manager",
    icon: <Building2 size={18} />,
  },
  {
    key: "VehicleMenu",
    path: "/vehicle",
    label: "Vehicle Manager",
    icon: <Car size={18} />,
  },
  {
    key: "VehicleModelMenu",
    path: "/vehicle-model",
    label: "Vehicle Model Manager",
    icon: <Boxes size={18} />,
  },
  {
    key: "ProductMenu",
    path: "/product",
    label: "Product Manager",
    icon: <Package size={18} />,
  },
  {
    key: "ProductPriceMenu",
    path: "/product-price",
    label: "Product Price Manager",
    icon: <IndianRupee size={18} />,
  },
  {
    key: "CatalogueMenu",
    path: "/catalogue",
    label: "Catalogue Manager",
    icon: <BookOpen size={18} />,
  },
  {
    key: "SubscriptionMenu",
    path: "/subscription",
    label: "Subscription Manager",
    icon: <CurlyBraces size={18} />,
  },
  {
    key: "SchemesMenu",
    path: "/schemes",
    label: "Schemes Manager",
    icon: <FolderTree size={18} />,
  },
  {
    key: "StateMenu",
    path: "/state",
    label: "State Manager",
    icon: <Flag size={18} />,
  },
  {
    key: "CityMenu",
    path: "/city",
    label: "City Manager",
    icon: <Building size={18} />,
  },
  {
    key: "FeedbackMenu",
    path: "/feedback",
    label: "Feedback Manager",
    icon: <ListCheck size={18} />,
  },
  {
    key: "CMSMenu",
    path: "/cms",
    label: "CMS Manager",
    icon: <ListCheck size={18} />,
  },
  {
    key: "SettingMenu",
    path: "/setting",
    label: "Setting Manager",
    icon: <Settings size={18} />,
  },
]

function Sidenav({ color }) {

  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const { userProfile, logout } = useContext(AuthContext)
  const { confirm } = Modal;
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [menuLinks, setMenuLinks] = useState([]);
  const [menuMode, setMenuMode] = useState('vertical');
  const [currentDateTime, setCurrentDateTime] = useState(moment());

  const showDeleteConfirm = (record) => {
    setTimeout(() => {
      confirm({
        okText: 'Logout',
        okType: 'danger',
        icon: <QuestionCircleFilled />,
        cancelText: 'Cancel',
        content: <Button >Are you sure you want to logout ?</Button>,
        zIndex: 1000,
        onOk() {
          logout();
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }, 5);
  };

  useEffect(() => {
    setLoading(true)
    if (!userProfile) return
    if (userProfile.user_type == 'Admin') {
      setMenuLinks(menuItems)
      setLoading(false)
      return
    }
    const newArray = menuItems.filter(item => {
      if (item.children) {
        item.children = item.children.filter(child => userProfile.permission?.hasOwnProperty(child.key));
      } else {
        return userProfile.permission?.hasOwnProperty(item.key)
      }
      return item
    });

    const links = newArray.filter(item => {
      if (item?.children?.length) {
        return true
      } else if (!item?.children) {
        return true
      } else {
        return false
      }
    })
    setMenuLinks(links)
  }, [userProfile])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMenuMode('inline');
      } else {
        setMenuMode('vertical');
      }
    }

    window.addEventListener('resize', handleResize);

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>

      <img src={logo} className="brand w-100 px-4 px-8 mt-2 " alt="" />

      <p className="text-center mb-2">Current Time : {currentDateTime.format("YYYY-MM-DD hh:mm A")}</p>

      {
        loading ? [1, 2, 3, 4, 5, 6].map(item => <Skeleton active key={item} />)
          :
          <Menu inlineCollapsed={false} mode={menuMode} className="sideNavMain">
            {menuLinks.map(item => {
              if (item.children) {
                return (
                  <Menu.SubMenu
                    key={item.key}
                    title={
                      <>
                        <span className="icon">{item.icon}</span>
                        <span className="label">{item.label}</span>
                      </>
                    }
                  >
                    {item.children.map(child => (
                      <Menu.Item key={child.key}>
                        <NavLink to={child.path}>{child.label}</NavLink>
                      </Menu.Item>
                    ))}
                  </Menu.SubMenu>
                );
              }

              return (
                <Menu.Item key={item.key}>
                  <NavLink to={item.path}>
                    <span className="icon">{item.icon}</span>
                    <span className="label">{item.label}</span>
                  </NavLink>
                </Menu.Item>
              );
            })}


            <Menu.Item>
              <a onClick={showDeleteConfirm}>
                <>
                  <span className="icon">{<LogOutIcon size={18} />}</span>
                  <span className="label">Logout </span>
                </>
              </a>
            </Menu.Item>

          </Menu>
      }

    </>
  );

}

export default Sidenav;
